module.exports = __webpack_public_path__ + "img/logo_liveperson_conversational_cloud.f46f551e.png";